import React from "react";
import { COLORS } from "../myDashboardConstants";

export function Avatar({
  initials,
  color = COLORS.primary,
  soft = COLORS.primarySoft,
}) {
  return (
    <span className="sd-avatar" style={{ color, background: soft }}>
      {initials}
    </span>
  );
}
